import {
  Button,
  Card,
  Col,
  Row,
  Select,
  Table,
  Tooltip,
  Input,
  Switch,
  Image,
} from "antd";
import moment from "moment";
import { UndoOutlined } from "@ant-design/icons";
import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Plus from "../../assets/images/plus.svg";
import SectionWrapper from "../../components/SectionWrapper";
import apiPath from "../../constants/apiPath";
import { attributeOption } from "../../constants/var";
import { AppStateContext } from "../../context/AppContext";
import { Severty, ShowToast } from "../../helper/toast";
import useDebounce from "../../hooks/useDebounce";
import useRequest from "../../hooks/useRequest";
import DeleteModal from "../../components/DeleteModal";
import AddForm from "./AddForm";
import EditIcon from "../../assets/images/edit.svg";
import { DeleteSubadmin } from "../../constants/reasons";
import { DownloadExcel } from "../../components/ExcelFile";
import notfound from "../../assets/images/not_found.png";

function Index() {
  const heading = "Product" + " " + "Management";
  const { setPageHeading } = useContext(AppStateContext);
  const sectionName = "Product";
  const routeName = "product";
  const params = useParams();
  const navigate = useNavigate()
  const [searchText, setSearchText] = useState("");
  const api = {
    list: apiPath.listProduct,
    addEdit: apiPath.listProduct,
    status: apiPath.listProduct + "/status",
  };

  const { request } = useRequest();
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [visible, setVisible] = useState(false);
  const [selected, setSelected] = useState();
  const [showDelete, setShowDelete] = useState(false);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const debouncedSearchText = useDebounce(searchText, 300);
  const [showMessage, setShowMessage] = useState(false);
  const [showStatusMessage, setShowStatusMessage] = useState(false);
  const [paramsIds, setParamsIds] = useState({});
  const [exportLoading, setExportLoading] = useState(false);
  const [filter, setFilter] = useState({});
  const [categories, setCategories] = useState([]);
  const [challenges, setChallenges] = useState([]);
  const onDelete = (id) => {
    request({
      url: api.addEdit + "/" + id,
      method: "DELETE",
      onSuccess: (data) => {
        setLoading(false);
        ShowToast(data.message, Severty.SUCCESS);
        setRefresh((prev) => !prev);
      },
      onError: (error) => {
        setLoading(false);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const handleChangeStatus = (id, message) => {
    request({
      url: api.status + "/" + id,
      method: "PUT",
      data: { message },
      onSuccess: (data) => {
        setLoading(false);
        setRefresh((prev) => !prev);
        ShowToast(data.message, Severty.SUCCESS);
      },
      onError: (error) => {
        console.log(error);
        setLoading(false);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const columns = [
    {
      title: "Product Image",
      dataIndex: "thumbnail",
      key: "thumbnail",
      render: (_, { thumbnail }) => (
        <Image
          width={50}
          src={thumbnail ? thumbnail : notfound}
          className="table-img"
        />
      ),
    },
    {
      title: "Category Name",
      dataIndex: "category_id",
      key: "category_id",
      width: 200,
      sorter: (a, b) =>
        a?.category_id?.name?.localeCompare(b?.category_id?.name),
      sortDirections: ["ascend", "descend"],
      render: (_, { category_id }) =>
        category_id?.name ? (
          <span className="cap">{category_id?.name}</span>
        ) : (
          "-"
        ),
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: 200,
      sorter: (a, b) => a?.name?.localeCompare(b?.name),
      sortDirections: ["ascend", "descend"],
      render: (_, { name }) =>
        name ? <span className="cap">{name}</span> : "-",
    },
   
   
    {
      title: "Register Date",
      key: "created_at",
      dataIndex: "created_at",
      render: (_, { created_at }) => {
        return moment(created_at).format("ll");
      },
    },

    {
      title: "Status",
      key: "is_active",
      dataIndex: "is_active",
      filters: [
        {
          text: "Active",
          value: "true",
        },
        {
          text: "InActive",
          value: "false",
        },
      ],
      render: (_, { _id, is_active, have_active_item }) => {
        return (
          <Switch
            onChange={() => {
              if (have_active_item) {
                return setShowStatusMessage(true);
              }
              handleChangeStatus(_id);
            }}
            checked={is_active}
          />
        );
      },
    },
    {
      title: "Action",
      fixed: "right",
      key: "action",
      render: (_, record) => {
        return (
          <div className="action-buttons-containermain">
             <Tooltip title={("View")} color={"purple"} key={"View"}>
              <Button
                title="View"
                className="edit-cls primary_btn"
                
                onClick={() => {
                  setSelected(record);
                  navigate(`/view-product/${record._id}`);
                }}
              >
               
                <i style={{ color: "fff" }} class="far fa-eye"></i>
              
              </Button>
            </Tooltip>
            <Tooltip
              title={"Edit"}
              color={"purple"}
              key={"Edit" + routeName}
              className="main-second-classforedit-5"
            >
              <Button
                title={"Edit"}
                className="edit-cls btnStyle primary_btn"
                onClick={() => {
                  setSelected(record);
                  setVisible(true);
                }}
              >
                <img src={EditIcon} />
                {/* <span>{"Edit"}</span> */}
              </Button>
            </Tooltip>
           
            <Tooltip
              title={"Delete"}
              color={"purple"}
              key={"delete" + routeName}
            >
              <Button
                className="delete-cls"
                title={"Delete"}
                onClick={() => {
                  if (record.have_item) {
                    return setShowMessage(true);
                  }
                  setSelected(record);
                  setShowDelete(true);
                }}
              >
                <i className="fa fa-light fa-trash"></i>
                {/* <span>{"Delete"}</span> */}
              </Button>
            </Tooltip>
          </div>
        );
      },
    },
  ];

  const getCategory = () => {
    request({
      url: apiPath.common.categories,
      method: "GET",
      onSuccess: ({ data, status }) => {
        if (status) {
          setCategories(data?.data ?? []);
        }
        console.log(data, "data");
      },
      onError: (err) => {
        console.log(err);
      },
    });
  };

  const getChallenge = () => {
    request({
      url: apiPath.common.challenges,
      method: "GET",
      onSuccess: ({ data, status }) => {
        if (status) {
          setChallenges(data?.data ?? []);
        }
        console.log(data, "data");
      },
      onError: (err) => {
        console.log(err);
      },
    });
  };

  const onChange = (key, value) => {
    setFilter((prev) => ({ ...prev, [key]: value }));
  };

  useEffect(() => {
    setLoading(true);
    fetchData(pagination);
    getCategory();
    getChallenge();
  }, [refresh, debouncedSearchText, filter]);

  useEffect(() => {
    setPageHeading(heading);
  }, [setPageHeading]);

  const fetchData = (pagination, filters) => {
    const filterActive = filters ? filters.is_active : null;

    const queryString = Object.entries(filter)
      .filter(([_, v]) => v)
      .map(
        ([key, value]) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
      )
      .join("&");

    request({
      url:
        api.list +
        `/?status=${filterActive ? filterActive.join(",") : ""}&page=${
          pagination ? pagination.current : 1
        }&pageSize=${pagination.pageSize ?? 10}&search=${debouncedSearchText}${
          queryString ? `&${queryString}` : ""
        }`,
      method: "GET",
      onSuccess: ({ data, status, total }) => {
        setLoading(false);
        console.log(data, "data11");
        if (status) {
          setList(() => {
            return data.docs.map((item) => {
              return {
                ...item,
                key: item._id,
              };
            });
          });
          setPagination((prev) => ({
            pageSize: pagination.pageSize,
            current: pagination.current,
            total: data.totalDocs,
          }));
        }
      },
      onError: (error) => {
        console.log(error);
        setLoading(false);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const handleChange = (pagination, filters) => {
    fetchData(pagination, filters);
  };

  const onSearch = (e) => {
    setSearchText(e.target.value);
    setPagination({ current: 1, pageSize: pagination.pageSize });
  };

  const getExportData = async () => {
    try {
      const queryString = Object.entries(filter)
        .filter(([_, v]) => v != undefined)
        .map(
          ([key, value]) =>
            `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
        )
        .join("&");
      setExportLoading(true);
      request({
        url:
          api.list +
          `?page=${pagination ? pagination.current : 1}&pageSize=${
            pagination.pageSize ?? 10
          }&search=${debouncedSearchText}${
            queryString ? `&${queryString}` : ""
          }`,
        method: "GET",
        onSuccess: ({ data, status, total, message }) => {
          setExportLoading(false);
          if (status) {
            excelData(data.docs ?? []);
          }
        },
        onError: (error) => {
          console.log(error);
          setExportLoading(false);
          ShowToast(error, Severty.ERROR);
        },
      });
    } catch (err) {
      console.log(err);
      setExportLoading(false);
    }
  };

  const excelData = (exportData) => {
    if (!exportData.length) return;

    const data = exportData.map((row) => ({
      Name: row?.name || "-",
      Category: row?.category_id?.name || "-",
      description: row?.description || "-",
      thumbnail: row?.thumbnail ? row?.thumbnail : "-",
      "Registered On": moment(row.created_at).format("DD-MM-YYYY"),
    }));
    DownloadExcel(data, sectionName);
  };

  return (
    <>
      <div className="tabled quoteManagement">
        <Row gutter={[24, 0]}>
          <Col xs={24} xl={24}>
            <Card bordered={false} className="criclebox tablespace mb-24">
              <SectionWrapper
                cardHeading={"All Products"}
                cardSubheading={""}
                extra={
                  <>
                    {/* <div className="button_group justify-content-end w-100"> */}
                    <div className="w-100 text-head_right_cont">
                      <div className="pageHeadingSearch">
                        <Input.Search
                          className="searchInput"
                          placeholder={"Search by product name"}
                          onChange={onSearch}
                          allowClear
                          value={searchText}
                        />
                      </div>

                      <div className="btn_grp">
                        <Button
                          loading={exportLoading}
                          onClick={() => getExportData()}
                          className="primary_btn btnStyle"
                        >
                          {"Export to Excel"}
                        </Button>
                      </div>
                      <Button
                        className="ms-sm-2 primary_btn btnStyle"
                        onClick={(e) => {
                          setVisible(true);
                          setParamsIds(params);
                        }}
                      >
                        <span className="add-Ic">
                          <img src={Plus} />
                        </span>
                        {"Add"} {routeName}
                      </Button>
                    </div>
                  </>
                }
              >
                <div className="table-responsive customPagination">
                  <Table
                    loading={loading}
                    columns={columns}
                    dataSource={list}
                    pagination={{
                      current: pagination?.current,
                      defaultPageSize: 10,
                      responsive: true,
                      total: pagination.total,
                      showSizeChanger: true,
                      showQuickJumper: true,
                    }}
                    onChange={handleChange}
                    className="ant-border-space"
                  />
                </div>
              </SectionWrapper>
            </Card>
          </Col>
        </Row>
      </div>

      {visible && (
        <AddForm
          section={sectionName}
          api={api}
          show={visible}
          paramsIds={paramsIds}
          hide={() => {
            setSelected();
            setVisible(false);
          }}
          data={selected}
          categories={categories}
          challenges={challenges}
          refresh={() => setRefresh((prev) => !prev)}
        />
      )}
      {showMessage && (
        <DeleteModal
          title={"Delete Product"}
          subtitle={
            "This Product contains Products, please remove  this  from Product before deleting Product"
          }
          show={showMessage}
          hide={() => {
            setShowMessage(false);
          }}
          onOk={() => setShowMessage(false)}
          reasons={[]}
        />
      )}
      {showStatusMessage && (
        <DeleteModal
          title={"Inactive Product"}
          subtitle={
            "This Product contains  Active Products, please inactive Product before deactivating  Product"
          }
          show={showStatusMessage}
          hide={() => {
            setShowStatusMessage(false);
          }}
          onOk={() => setShowStatusMessage(false)}
          reasons={[]}
        />
      )}
      {showDelete && (
        <DeleteModal
          title={"Delete Product"}
          subtitle={`Are you sure you want to Delete this Product?`}
          show={showDelete}
          hide={() => {
            setShowDelete(false);
            setSelected();
          }}
          onOk={() => onDelete(selected?._id)}
          reasons={DeleteSubadmin}
        />
      )}
    </>
  );
}

export default Index;
